module.exports = __webpack_public_path__ + "img/W7028-trad.1cc0f15a.jpg";